const RolesRouter = {
  path: '/roles',
  component: () => import('@/views/layout'),
  redirect: '/roles/manage/list',
  alwaysShow: true,
  meta: {
    title: '权限管理',
    icon: require('@/assets/slider/setting.png')
  },
  children: [
    {
      path: 'manage/list',
      name: 'rolelist',
      component: () => import('@/views/jurisdiction/role'),
      meta: { title: '角色管理', icon: '', keepAlive: true }
    }, {
      path: 'member/list',
      name: 'memberlist',
      component: () => import('@/views/jurisdiction/member'),
      meta: { title: '用户管理', icon: '', keepAlive: true }
    }, {
      path: 'company/list',
      name: 'companylist',
      component: () => import('@/views/jurisdiction/company'),
      meta: { title: '公司管理', icon: '', keepAlive: true }
    },
    {
      path: 'department/list',
      name: 'department',
      component: () => import('@/views/jurisdiction/department'),
      meta: { title: '部门管理', icon: '', keepAlive: true }
    },
    {
      path: 'contract/list',
      name: 'contract_company',
      component: () => import('@/views/jurisdiction/contract_company'),
      meta: { title: '合同公司', icon: '', keepAlive: true }
    },
    {
      path: 'customer/list',
      name: 'contract_member',
      component: () => import('@/views/jurisdiction/contract_member'),
      meta: { title: '客户管理', icon: '', keepAlive: true }
    }
  ]
}
const RolesDescRouter = {
  path: '/roles',
  component: () => import('@/views/layout'),
  hidden: true,
  meta: {
    title: 'desc'
  },
  children: [
    {
      path: 'authorization/:id',
      name: 'authorization',
      hidden: true,
      component: () => import('@/views/jurisdiction/authorization'),
      meta: { title: '详情', icon: '' }
    }, {
      path: 'memberauth/:id',
      name: 'memberauth',
      hidden: true,
      component: () => import('@/views/jurisdiction/member_auth'),
      meta: { title: '详情', icon: '' }
    }
  ]
}
export { RolesRouter, RolesDescRouter }
